import React from 'react';
import { Switch, Route } from 'wouter';
import MainLayout from '@/layouts/MainLayout';
import ProgramariRouteGuard from '@/components/common/ProgramariRouteGuard';
import { lazyWithPreload } from '@/utils/lazyWithPreload';
import { WEBREADY_LEGAL_ROUTES } from '@/lib/webreadyLegal';

const Home = lazyWithPreload(() => import('@/pages/Home'));
const Services = lazyWithPreload(() => import('@/pages/Services'));
const ServiceDetails = lazyWithPreload(() => import('@/pages/ServiceDetails'));
const ServiceDetailsRouteWrapper = lazyWithPreload(
  () => import('@/components/services/ServiceDetailsRouteWrapper')
);
const Team = lazyWithPreload(() => import('@/pages/Team'));
const Gallery = lazyWithPreload(() => import('@/pages/Gallery'));
const Contact = lazyWithPreload(() => import('@/pages/Contact'));
const Blog = lazyWithPreload(() => import('@/pages/Blog'));
const BlogPostPage = lazyWithPreload(() => import('@/pages/BlogPostPage'));
const Testimonials = lazyWithPreload(() => import('@/pages/Testimonials'));
const Programari = lazyWithPreload(() => import('@/pages/Programari'));
const StaticPage = lazyWithPreload(() => import('@/pages/StaticPage'));
const BookAppointment = lazyWithPreload(() => import('@/pages/BookAppointment'));
const ConfirmAppointment = lazyWithPreload(() => import('@/pages/ConfirmAppointment'));
const NotFound = lazyWithPreload(() => import('@/pages/NotFound'));
const LegalDocumentRedirect = lazyWithPreload(() => import('@/pages/LegalDocumentRedirect'));
const WebReadyTermsPage = lazyWithPreload(() => import('@/pages/legal/WebReadyTermsPage'));
const WebReadyPrivacyPage = lazyWithPreload(() => import('@/pages/legal/WebReadyPrivacyPage'));
const WebReadyCookiesPage = lazyWithPreload(() => import('@/pages/legal/WebReadyCookiesPage'));
const SiteHubPage = lazyWithPreload(() => import('@/pages/SiteHubPage'));

/** Rute publice randate în interiorul MainLayout-ului persistent */
export function PublicRoutesSwitch() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/services/:serviceId" component={ServiceDetailsRouteWrapper} />
      <Route path="/service/:id" component={ServiceDetails} />
      <Route path="/services" component={Services} />
      <Route path="/about" component={StaticPage} />
      <Route path="/team" component={Team} />
      <Route path="/gallery" component={Gallery} />
      <Route path="/contact" component={Contact} />
      <Route path="/blog" component={Blog} />
      <Route path="/blog/:slug" component={BlogPostPage} />
      <Route path="/page/:slug" component={StaticPage} />
      <Route path="/site" component={SiteHubPage} />
      <Route path="/site/:slug" component={StaticPage} />
      <Route path="/articole-recente" component={StaticPage} />
      <Route path="/testimonials" component={Testimonials} />
      <Route path="/appointments">
        {() => (
          <ProgramariRouteGuard>
            <Programari />
          </ProgramariRouteGuard>
        )}
      </Route>
      <Route path="/book-appointment" component={BookAppointment} />
      <Route path="/confirm-appointment" component={ConfirmAppointment} />
      <Route path={WEBREADY_LEGAL_ROUTES.terms} component={WebReadyTermsPage} />
      <Route path={WEBREADY_LEGAL_ROUTES.privacy} component={WebReadyPrivacyPage} />
      <Route path={WEBREADY_LEGAL_ROUTES.cookies} component={WebReadyCookiesPage} />
      <Route path="/privacy-policy">
        {() => <LegalDocumentRedirect to={WEBREADY_LEGAL_ROUTES.privacy} />}
      </Route>
      <Route path="/terms-of-service">
        {() => <LegalDocumentRedirect to={WEBREADY_LEGAL_ROUTES.terms} />}
      </Route>
      <Route component={NotFound} />
    </Switch>
  );
}

const PublicLayoutShell = React.memo(function PublicLayoutShell() {
  return (
    <MainLayout>
      <PublicRoutesSwitch />
    </MainLayout>
  );
});

export default PublicLayoutShell;
